<template>
  <figure class="chapterhead-banner">
    <img class="chapterhead-banner__image" :src="imgSrc" />
    <h1 class="chapterhead-banner__title">{{ title }}</h1>
  </figure>
</template>

<script>
export default {
  name: "ChapterheadBanner",
  props: {
    title: String,
    image: Object,
  },
  computed: {
    imgSrc() {
      if (this.image) {
        return this.image.sourceUrl;
      }
      return null;
    },
  },
};
</script>

<style lang="scss">
.chapterhead-banner {
  height: 300px;
  margin: 0;
  overflow: hidden;
  position: relative;
  width: 100%;
  @include desktop() {
    height: 500px;
  }
  &__image {
    object-fit: cover;
    object-position: left top;
    width: 100%;
  }
  &__title {
    position: absolute;
    bottom: 10%;
    left: 2rem;
    color: white;
    width: 300px;
    font-size: 2rem;
    @include desktop() {
      left: 2rem;
      width: 400px;
      font-size: 3rem;
    }
  }
}
</style>
